module.exports = __webpack_public_path__ + "img/x1_en_2023_01_19@2x.89da60e7.png";